export function groupTabsByNopol(tabs) {
	return tabs.reduce((groups, tab) => {
		const existingGroup = groups.find(group => group.nopol === tab.nopol)

		if (existingGroup) {
			existingGroup.tabs.push(tab)
		} else {
			groups.push({
				nopol: tab.nopol,
				tabs: [tab]
			})
		}

		return groups
	}, [])
}

export function sumSjField(tabs, field) {
	return tabs.reduce((total, tab) => {
		const value = tab.sjData && tab.sjData[field]
		return total + Number(value || 0)
	}, 0)
}

export function getPendingSjGroups(tabs) {
	return groupTabsByNopol(
		tabs.filter(tab => tab.sjData && Number(tab.sjData.status_sj) === 0)
	)
}

export function getPendingRouteTabs(tabs) {
	return tabs.filter(tab => {
		const ruteData = tab.ruteData
		return Boolean(
			ruteData &&
			Number(ruteData.status_rute) === 0 &&
			Array.isArray(ruteData.child) &&
			ruteData.child.some(item => item.insert_id !== null && item.insert_id !== undefined)
		)
	})
}
